import { WidgetConfiguration } from "@sgwt-widget/core";

export class CProfitWidgetConfiguration {
  public environment: string;
  public soaUrl: () => string;
  public soaPrivateUrl: () => string;
  public monitoringUrl: string;
  public dataCompletionUrl: string;
  public secureAppLogin?: string;
  public secureAppPass?: string;
  public cprWebsiteUrl: string;
  public dashboardurl: string;
  public abacusurl: string;
  public auditTraceApiUrl: string;
  public constructor(configuration: WidgetConfiguration) {
    const environment = "production";
    const soaUrl = "https://cpr-bi-api.fr.world.socgen/2.0/";
    const soaPrivateUrl = "https://cpr-bi-api.fr.world.socgen/private/";
    const monitoringUrl = "https://360-log-api.fr.world.socgen/api/v1/logs/create";
    const dataCompletionUrl = "https://srvcldcpyp009.fr.world.socgen/api-automation/api/";
    const cprWebsiteUrl = "https://cprofit.sgmarkets.com";
    const dashboardurl = "https://dashboard.sgmarkets.com";
    const abacusUrl = "https://srvcldlipp035.fr.world.socgen:9595/";
    const auditTraceApiUrl = "%#ccpr-server.origin#%";
    if (environment.lastIndexOf("%#") !== -1) {
      this.environment = "HOM";
      this.soaUrl = () => this.getSoaUrl(configuration.environment);
      this.soaPrivateUrl = () =>
        this.getPrivateSoaUrl(configuration.environment);
      this.monitoringUrl =
        "https://cli-log-api-uat.fr.world.socgen/api/monitoring/create";
      this.dataCompletionUrl =
        "https://srvcldcpyp009.fr.world.socgen/api-automation/api/";
      this.cprWebsiteUrl = "https://cprofit.sgmarkets.com/sso/";
      this.dashboardurl = "https://sg-dashboard-uat.fr.world.socgen";
      this.abacusurl = "https://srvcldstad083.fr.world.socgen:4443";
      this.auditTraceApiUrl = "https://cpr-audittrace-api-uat.fr.world.socgen/";
    } else {
      this.environment = environment;
      this.soaUrl = () => soaUrl;
      this.soaPrivateUrl = () => soaPrivateUrl;
      this.monitoringUrl = monitoringUrl;
      this.dataCompletionUrl = dataCompletionUrl;
      this.cprWebsiteUrl = cprWebsiteUrl;
      this.dashboardurl = dashboardurl;
      this.abacusurl = abacusUrl;
      this.auditTraceApiUrl = auditTraceApiUrl;
    }
  }

  private getSoaUrl(environment: string) {
    return this.getSoaUrlTemplate(environment) + "2.0/"; // main/v2/;
  }

  private getPrivateSoaUrl(environment: string) {
    return this.getSoaUrlTemplate(environment) + "private/"; // private/v1/
  }

  private getSoaUrlTemplate(environment: string) {
    if (environment === "production") {
      return "https://cpr-bi-api.fr.world.socgen/";
    } else {
      return "https://cpr-bi-api-uat.fr.world.socgen/";
    }
  }
}
